"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomizedComponents = getCustomizedComponents;
var _Accordion = require("./customize/Accordion.customize");
var _Alert = require("./customize/Alert.customize");
var _Autocomplete = require("./customize/Autocomplete.customize");
var _Avatar = require("./customize/Avatar.customize");
var _Breadcrumbs = require("./customize/Breadcrumbs.customize");
var _Badge = require("./customize/Badge.customize");
var _Button = require("./customize/Button.customize");
var _ButtonGroup = require("./customize/ButtonGroup.customize");
var _Card = require("./customize/Card.customize");
var _Checkbox = require("./customize/Checkbox.customize");
var _Chip = require("./customize/Chip.customize");
var _Fab = require("./customize/Fab.customize");
var _FormHelperText = require("./customize/FormHelperText.customize");
var _Link = require("./customize/Link.customize");
var _Dialog = require("./customize/Dialog.customize");
var _Divider = require("./customize/Divider.customize");
var _InputBase = require("./customize/InputBase.customize");
var _Menu = require("./customize/Menu.customize");
var _Paper = require("./customize/Paper.customize");
var _Radio = require("./customize/Radio.customize");
var _Rating = require("./customize/Rating.customize");
var _Select = require("./customize/Select.customize");
var _Slider = require("./customize/Slider.customize");
var _Skeleton = require("./customize/Skeleton.customize");
var _Snackbar = require("./customize/Snackbar.customize");
var _Switch = require("./customize/Switch.customize");
var _Tabs = require("./customize/Tabs.customize");
var _CircularProgress = require("./customize/CircularProgress.customize");
var _TextField = require("./customize/TextField.customize");
var _ToggleButton = require("./customize/ToggleButton.customize");
var _Tooltip = require("./customize/Tooltip.customize");
var _Typography = require("./customize/Typography.customize");
/* eslint-disable import/max-dependencies */

// Include MuiDataGrid in the theme https://github.com/mui-org/material-ui-x/issues/1755
// eslint-disable-next-line import/no-unassigned-import

// Export components
function getCustomizedComponents(palette) {
  return {
    MuiAccordion: (0, _Accordion.getMuiAccordion)(palette),
    MuiAlert: (0, _Alert.getMuiAlert)(palette),
    MuiAutocomplete: (0, _Autocomplete.getMuiAutoComplete)(palette),
    MuiAvatar: (0, _Avatar.getMuiAvatar)(palette),
    MuiBadge: (0, _Badge.getMuiBadge)(palette),
    MuiBreadcrumbs: (0, _Breadcrumbs.getMuiBreadcrumbs)(palette),
    MuiButton: (0, _Button.getMuiButton)(palette),
    MuiButtonBase: (0, _Button.getMuiButtonBase)(),
    MuiButtonGroup: (0, _ButtonGroup.getMuiButtonGroup)(palette),
    MuiCard: (0, _Card.getMuiCard)(palette),
    MuiCheckbox: (0, _Checkbox.getMuiCheckbox)(palette),
    MuiChip: (0, _Chip.getMuiChip)(palette),
    MuiCircularProgress: (0, _CircularProgress.getMuiCircularProgress)(palette),
    MuiDialog: (0, _Dialog.getMuiDialog)(palette),
    MuiDivider: (0, _Divider.getMuiDivider)(palette),
    MuiFab: (0, _Fab.getMuiFab)(palette),
    MuiFormHelperText: (0, _FormHelperText.getMuiFormHelperText)(),
    MuiInputBase: (0, _InputBase.getMuiInputBase)(palette),
    MuiLink: (0, _Link.getMuiLink)(palette),
    MuiMenu: (0, _Menu.getMuiMenu)(),
    MuiMenuItem: (0, _Menu.getMuiMenuItem)(palette),
    MuiPaper: (0, _Paper.getMuiPaper)(palette),
    MuiRadio: (0, _Radio.getMuiRadio)(palette),
    MuiRating: (0, _Rating.getMuiRating)(),
    MuiSelect: (0, _Select.getMuiSelect)(palette),
    MuiSkeleton: (0, _Skeleton.getMuiSkeleton)(palette),
    MuiSlider: (0, _Slider.getMuiSlider)(palette),
    MuiSnackbar: (0, _Snackbar.getMuiSnackbar)(palette),
    MuiSwitch: (0, _Switch.getMuiSwitch)(palette),
    MuiTabs: (0, _Tabs.getMuiTabs)(palette),
    MuiTextField: (0, _TextField.getMuiTextField)(palette),
    MuiToggleButton: (0, _ToggleButton.getMuiToggleButton)(palette),
    MuiToggleButtonGroup: (0, _ToggleButton.getMuiToggleButtonGroup)(palette),
    MuiTooltip: (0, _Tooltip.getMuiTooltip)(palette),
    MuiTypography: (0, _Typography.getMuiTypography)(palette)
  };
}